import React from 'react';
import { useHistory } from 'react-router-dom';
import { TabPanel } from 'primereact/tabview';
import { TabViewStyled } from 'styles/v2/Styles.styled';
import { EPDDefinitionModel } from 'types/epd-definition/EPDDefinitionModel';
import { CompilerCompositeStatusModel } from 'types/types';
import ContentDeclarationTab from './ContentDeclarationTab';
import { CompilerFieldMatcher, getStateForFields } from './CompilerStepsValidator';
import StepTabHeader from './StepTabHeader';
import ProductInformationTab from './ProductInformationTab';
import TechnicalPerformanceTab from './TechnicalPerformanceTab';
import { EpdLinks } from 'routes/EpdRoutes';
import { compilerStep2Tabs } from './compilerNavConstants';

const productInformationTabFields: CompilerFieldMatcher[] = ['products', /^products\[\d+\]$/];

const technicalPerformanceTabFields: CompilerFieldMatcher[] = ['technicalPerformance'];

const contentDeclarationTabFields: CompilerFieldMatcher[] = [
  'serviceIncludesProductInSystemBoundary',
  'declarationIrrelevanceExplanation',
  'averageProductContentDeclarationDescription',
  'averageProductComponents',
  'packagingMaterialApplicable',
  'averagePackagingMaterials',
  'averagePanelContents',
  'averageDangerMaterials',
  'comparisonWorstAndBestCase',
];

const Step2: React.FunctionComponent<{
  epdId: string;
  epdVersionId: string | undefined;
  tab: string | null | undefined;
  epdDefinition: EPDDefinitionModel | undefined;
  validationState: CompilerCompositeStatusModel | undefined;
}> = ({ epdId, epdVersionId, tab, epdDefinition, validationState }) => {
  const history = useHistory();

  let tabIndex = compilerStep2Tabs.findIndex((t) => t === tab);
  if (tabIndex === -1) {
    tabIndex = 0;
  }

  const errors = validationState?.errors;

  const productInformationTabState = getStateForFields(productInformationTabFields, errors);
  const technicalPerformanceTabState = getStateForFields(technicalPerformanceTabFields, errors);
  const contentDeclarationTabState = getStateForFields(contentDeclarationTabFields, errors);

  return (
    <TabViewStyled
      activeIndex={tabIndex}
      onTabChange={(e) =>
        history.push(EpdLinks.epdCompilerSpecific(epdId, { step: 'step2', tab: compilerStep2Tabs[e.index] }))
      }
    >
      <TabPanel header={<StepTabHeader title="Product information" state={productInformationTabState} />}>
        <ProductInformationTab
          epdId={epdId}
          epdVersionId={epdVersionId!}
          epdClassification={epdDefinition?.epdClassification}
          validationState={validationState}
        />
      </TabPanel>
      <TabPanel header={<StepTabHeader title="Technical performance" state={technicalPerformanceTabState} />}>
        <TechnicalPerformanceTab epdVersionId={epdVersionId!} validationState={validationState} />
      </TabPanel>
      <TabPanel header={<StepTabHeader title="Content declaration" state={contentDeclarationTabState} />}>
        <ContentDeclarationTab epdId={epdId} epdVersionId={epdVersionId!} validationState={validationState} />
      </TabPanel>
    </TabViewStyled>
  );
};

export default Step2;
